import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import mqtt_topics from "../../../mqtt/mqtt_topics";
import "./../../../css/app.css";

const Combobox = (props) => {
  const mac = mqtt_topics.choosenmac;
  const [state, setState] = useStateIfMounted({
    value: props.values[0],
    values: props.values,
    title: props.title, //"Normal UI"
    disabled: false, //if returned value == na set to false
    progress: false,
    acc: props.acc,
  });
  const target_live_reading_topic =
    mqtt_topics.fixed_topic_part +
    mac +
    "/" +
    props.category +
    "/" +
    props.subcategory +
    "/" +
    props.title;

  function listenforlivedata() {
    props.mqttClient.subscribe(target_live_reading_topic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == target_live_reading_topic) {
      try {
        // message is Buffer
        message = JSON.parse(message.toString());
        if (message.value.toLowerCase().toString() == "nv") {
          setState({
            ...state,
            disabled: true,
            progress: false,
          });
        } else {
          setState({
            ...state,
            value: message.value == undefined ? "" : message.value,
            disabled: false,
            progress: false,
          });
        }
      } catch (error) {
        //console.log(message);
      }
    }
  }

  useEffect(() => {
    listenforlivedata();
  }, []);

  //when componenet unmount
  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(target_live_reading_topic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  function setparameter(val) {
    if (!mqtt_topics.busy_Requesting_Data) {
      requestdata(val);
    } else {
      setTimeout(function () {
        requestdata(val);
      }, mqtt_topics.timeouttotrytorequestmqttdata); //wait 1 seconds
    }
  }

  function requestdata(val) {
    mqtt_topics.busy_Requesting_Data = true;
    props.mqttClient.publish(
      mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
      JSON.stringify({
        param: props.category + "/" + props.subcategory + "/" + props.title,
        value: val.toString(),
      })
    );
    mqtt_topics.busy_Requesting_Data = false;
  }

  //className="form-check-input" className="form-check-label"
  return (
    <div
      className="grid-item"
      style={{ display: state.disabled ? "none" : "block" }}
    >
      <div
        className="d-flex align-items-center"
        style={{
          display: state.progress ? "none" : "block",
        }}
      >
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">{state.title}</span>
          </div>
          <button
            className="btn btn-secondary dropdown-toggle"
            type="button"
            id={props.category + "_" + props.subcategory + "_" + props.title}
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            style={{ backgroundColor: "#9e9ea0" }}
            disabled={!state.acc}
          >
            {state.value}
          </button>
          <div
            className="dropdown-menu"
            aria-labelledby={
              props.category + "_" + props.subcategory + "_" + props.title
            }
          >
            {state.values.map((choice) => (
              <a
                className="dropdown-item"
                key={
                  props.category +
                  "_" +
                  props.subcategory +
                  "_" +
                  props.title +
                  "_" +
                  choice.toString()
                }
                onClick={() => {
                  if (choice !== state.value) {
                    setparameter(choice);
                    setState({
                      ...state,
                      value: choice,
                      progress: true,
                    });
                  }
                }}
              >
                {choice}
              </a>
            ))}
          </div>
        </div>
      </div>
      <div
        className="spinner-border text-primary"
        style={{ display: state.progress ? "block" : "none" }}
      ></div>
    </div>
  );
};
export default Combobox;
